module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis5-5b02e20a922f842adec846382bcaebd1.jpg";